// Dangerous attachment file extensions rejected client-side (security audit finding).
// Extension-based blocklist — matched case-insensitively against the file's FINAL extension.
// Grouped by category; "variant" entries resist trivial evasion of the same list.
// 33 audit-list + 13 variants + 4 review-added (pif, ws, command, msc) = 50 total, no duplicates.
export const BLOCKED_ATTACHMENT_EXTENSIONS = [
  // Executables / installers
  'exe', 'dll', 'com', 'msi', 'scr', 'apk', 'app', 'msix', 'appx', 'pif',
  // Scripts
  'sh', 'bat', 'cmd', 'ps1', 'ps1xml', 'js', 'jse', 'vbs', 'vbe',
  'py', 'jar', 'wsf', 'wsh', 'ws', 'hta', 'jnlp', 'gadget', 'command',
  // Macro-enabled Office
  'docm', 'xlsm', 'pptm', 'xll',
  // Active web content
  'html', 'htm', 'mhtml', 'mht', 'svg', 'xml',
  // Shortcuts / system configuration
  'lnk', 'url', 'reg', 'cpl', 'inf', 'scf', 'msc',
  // Disk images
  'iso', 'img', 'dmg', 'vhd', 'vhdx',
];
